import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import '../styles/FrontPage.css';
import "../styles/portfolioStyles.css";

const PortfolioPage = () => {
  const { username } = useParams(); // Retrieve the username from the URL
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const docRef = doc(db, "joyousApplications", username);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setUserData(docSnap.data());
        } else {
          const errMsg = `No document found for username: ${username}`;
          console.error(errMsg);
          setError(errMsg);
        }
      } catch (err) {
        const errorMessage = err.message || "Error fetching data from Firestore";
        console.error("Error fetching portfolio data:", err);
        setError(errorMessage);
      }
    };

    fetchUserData();
  }, [username]);

  // If an error occurred, display it so you know what went wrong.
  if (error) {
    return (
      <div style={{ padding: "2rem", maxWidth: "600px", margin: "auto", color: "red" }}>
        Error: {error}
      </div>
    );
  }

  // Show loading message until data is available.
  if (!userData) {
    return <div style={{ padding: "2rem", maxWidth: "600px", margin: "auto" }}>Loading...</div>;
  }

  // Once data is fetched, display it.
  return (
    <div style={{ padding: "2rem", maxWidth: "600px", margin: "auto" }}>
      <h2 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
        Welcome, {userData.name}!
      </h2>
      <p style={{ marginBottom: "1.5rem", color: "#555" }}>
        Your portfolio info:
      </p>
      <div className="portfolio-info" style={{ lineHeight: "1.8" }}>
        <p><strong>Name:</strong> {userData.name}</p>
        <p><strong>Email:</strong> {userData.email}</p>
        <p><strong>About:</strong> {userData.bio}</p>
        <p><strong>Username:</strong> {username}</p>
      </div>
    </div>
  );
};

export default PortfolioPage;
